import {Link} from 'react-router-dom';
import moment from 'moment-timezone';
import React from 'react';

export const MainNotices = ({notices}) => (
  <section className="main-notices">
    <div className="main-notices__header">
      <h1>PC방 새소식</h1>
      <Link to="/news/notices" className="more">
        <span>더보기 +</span>
      </Link>
    </div>
    <ul className="main-notices__body">
      {notices.map((notice, index) => (
        <li key={index}>
          <Link to={`/news/notices/details/${notice.noticeId}`}>
            <span>
              {notice.title}
              {moment.utc(notice.created).isSameOrAfter(moment().add(-3, 'day')) && <em className="new">NEW</em>}
            </span>
            <span>
              {moment
                .utc(notice.created)
                .local()
                .format('YYYY.MM.DD')}
            </span>
          </Link>
        </li>
      ))}
    </ul>
  </section>
);
